import { SimNaoEnum } from 'components/form'

import { ExemplosVerticalFieldModel } from '../../components/ExemplosVerticalField'
import { ConsultaSeguimentoAplicacaoItemModel, PassouFalhouEnum } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta16ExemplosEnum {
  OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO = 'OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO',
  APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO = 'APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO',
  OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO = 'OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO',
  NAO_REPARA_EM_VOCE = 'NAO_REPARA_EM_VOCE',
  OLHA_PARA_SEU_ROSTO = 'OLHA_PARA_SEU_ROSTO',
}

export interface ConsultaSeguimentoPergunta16Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_16_HEADER?: SimNaoEnum
  PERGUNTA_16_EXEMPLOS?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta16ExemplosEnum>
  PERGUNTA_16_FREQUENCIA?: PassouFalhouEnum
}
